export default __webpack_public_path__ + "static/media/money_euro_filled.4b6f00c3.svg";